/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilityBaseResponse {
    getFixupPrototypeFunction() { return ThreatVulnerabilityBaseResponse.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilityBaseResponse>): ThreatVulnerabilityBaseResponse {
        let obj = Object.assign(new ThreatVulnerabilityBaseResponse(), model);
        ThreatVulnerabilityBaseResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilityBaseResponse>): ThreatVulnerabilityBaseResponse {
        if (!model) return null;
        return ThreatVulnerabilityBaseResponse.newInstance(<ThreatVulnerabilityBaseResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilityBaseResponse) {
        if (!obj) return;

        models.ThreatVulnerabilityBaseResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilityBaseResponse): boolean {
        Object.setPrototypeOf(obj, ThreatVulnerabilityBaseResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (typeof this.detected_at === "string") {
            this.detected_at = new Date(<string><any>this.detected_at);
        }
    }

    /**
     * ID of the service account to which the threat/vulnerability belongs to.
     */
    service_account_id: string;

    /**
     * Cloud Provider of the service account
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Tenant ID where the service account belongs to
     */
    tenant_id: string;

    /**
     * ID of the resource where the threat/vulnerability is observed
     */
    resource_id: string;

    /**
     * Name of the resource where the threat/vulnerability is observed
     */
    resource_name: string;

    /**
     * Category of the resource to which the threat/vulnerability belongs to.
     */
    resource_category: string;

    /**
     * Type of the resource to which the threat/vulnerability belongs to.
     */
    resource_type: string;

    /**
     * Resource to which the threat/vulnerability belongs to.
     */
    resource: string;

    /**
     * Region the impacted resource is located in.
     */
    region: string;

    /**
     * Location the impacted resource is located in.
     */
    location: string;

    /**
     * Resource Group of the resource to which the threat/vulnerability belongs to.
     */
    resource_group: string;

    /**
     * Severity of the threat/vulnerability
     */
    severity: models.Severity;

    /**
     * Status of the threats/vulnerabilities
     */
    status: models.ThreatVulnerabilityStatus;

    /**
     * Source of the threat/vulnerability
     */
    source: string;

    /**
     * Issue Type of the threat/vulnerability
     */
    issue_type: string;

    /**
     * Unique id for threat/vulnerability as provided by the cloud provider
     */
    provider_issue_id: string;

    /**
     * Title of the threat/vulnerability
     */
    title: string;

    /**
     * Date and time when the threat/vulnerability was created in corestack
     */
    created_at: Date;

    /**
     * Date and time when the threat/vulnerability was updated in corestack
     */
    updated_at: Date;

    /**
     * Description of the threat/vulnerability
     */
    description: string;

    /**
     * Date and time when the threat/vulnerability was detected
     */
    detected_at: Date;

    /**
     * Recommendation for the threat/vulnerability
     */
    recommendation: string;

    /**
     * Recommended remediation for the threat/vulnerability
     */
    remediation: string;

    /**
     * Source data of the threat/vulnerability captured from the cloud.
     */
    source_data: any;

}
